import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import VueResource from 'vue-resource';//引入资源请求插件
Vue.use(ElementUI) 
	import 'element-ui/lib/theme-chalk/display.css';//响应式布局
// import VueJsonp from 'vue-jsonp'//引入jsonp解决跨域
// Vue.use(VueJsonp)

import axios from 'axios' ; //引入axios
import VueAxios from 'vue-axios'
Vue.use(VueAxios,axios)


// import "../src/router/permission.js"//引入导航守卫js


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

// vue定义全局域名配置
	// Vue.http.options.root='http://192.168.100.3:8005/' 
	// Vue.http.options.root='f24o348093.qicp.vip:35591/' 
axios.defaults.baseURL="";
// axios.defaults.baseURL="http://192.168.100.3:8005";
//全局启用emulateJSON选项
  // Vue.http.options.emulateJSON=true;
  // axios.options.emulateJSON=true;
  axios.defaults.withCredentials = true;
  // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';



  // 关于cookie的哪些方法

  import {setCookie,getCookie,delCookie} from './assets/js/cookie.js'
  Vue.prototype.$cookieStore = {setCookie,getCookie,delCookie}

  //页面引入下拉触底函数的封装及时间函数
  import {getScrollHeight,getScrollTop,getWindowHeight,renderTime} from "./assets/js/screen.js";
  Vue.prototype.$getScrolls = {getScrollHeight,getScrollTop,getWindowHeight,renderTime}